// Voice Service - ElevenLabs TTS
const API_URL = process.env.REACT_APP_API_URL || "";

export async function speakWithXIA(text, onStart, onEnd) {
  // Limpiar texto para voz
  const cleanText = text
    .replace(/```[\s\S]*?```/g, " ")
    .replace(/`[^`]+`/g, " ")
    .replace(/\*\*([^*]+)\*\*/g, "$1")
    .replace(/#{1,6}\s*/g, "")
    .replace(/https?:\/\/\S+/g, " ")
    .replace(/\n+/g, ". ")
    .substring(0, 1000);
  
  if (onStart) onStart();
  
  try {
    const response = await fetch(`${API_URL}/api/voice/speak`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text: cleanText })
    });
    
    const data = await response.json();
    
    if (data.success && data.url) {
      return new Promise((resolve) => {
        const audio = new Audio(`${API_URL}${data.url}`);
        audio.onended = () => {
          if (onEnd) onEnd();
          resolve(true);
        };
        audio.onerror = () => {
          if (onEnd) onEnd();
          resolve(false);
        };
        audio.play().catch(() => {
          if (onEnd) onEnd();
          resolve(false);
        });
      });
    }
    if (onEnd) onEnd();
    return false;
  } catch (e) {
    console.error("Voice error:", e);
    if (onEnd) onEnd();
    return false;
  }
}

export async function translateText(text, targetLang = "inglés") {
  try {
    const response = await fetch(`${API_URL}/api/translate/translate`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text, targetLang })
    });
    return await response.json();
  } catch (e) {
    return { success: false, error: e.message };
  }
}
